// extracted by mini-css-extract-plugin
export var show = "KlaviyoForm-module--show--7359Y";
export var hide = "KlaviyoForm-module--hide--pz7nC";
export var emailInput = "KlaviyoForm-module--emailInput--z0AUc";
export var emailCheckbox = "KlaviyoForm-module--emailCheckbox--fc8uQ";